module.exports = __webpack_public_path__ + "img/王小宁@2x.bce3a9a1.png";